import React, {useEffect, useState} from 'react';
import './Loader.css';
export function Loader({size = 'normal', padded = false}) {
  const [classes, setClasses] = useState('');
  useEffect(() => {
    let cls = [];
    if (size === 'large') {
      cls.push('loader--large');
    }
    if (padded) {
      cls.push('loader--padded');
    }
    setClasses(cls.length > 0 ? ' ' + (cls.join(' ')) : '');
  }, [size, padded]);

  return <div className={"loader" + classes}></div>;
};
